module.exports = __webpack_public_path__ + "img/CZ07639996.0939055a.png";